import axios from "./axios";

export const getLogs = (token, data) => {
  const queryParams = { ...data };
  delete queryParams.token;
  return axios.get("/fetch-log", {
    headers: {
      "API-TOKEN": token,
    },
    params: queryParams,
  });
};
